import { addDefinition } from './classes/object-definition';
import { deserialize } from './methods/deserialize';
import { serialize } from './methods/serialize';
export class JSON {
    static deserialize(object, type, options, genericType) {
        // outermost object is not a property of anything else we're deserializing, property = undefined.
        return deserialize(object, undefined, type, options, genericType, true);
    }
    static parse(json, type, options) {
        return this.deserialize(global.JSON.parse(json), type, options);
    }
    static serialize(value, genericType, type) {
        // outermost object is not a property of anything else we're serializing, property = undefined.
        return serialize(value, undefined, type, genericType, true);
    }
    static stringify(object, replacer, space, genericType) {
        return global.JSON.stringify(this.serialize(object, genericType), replacer, space);
    }
    static validate(object, type) {
        const actualType = type ?? object.constructor;
        const definition = addDefinition(actualType);
        // serialize checks schema of its output if a schema has been registered for this type using @JsonSchema
        if (!definition.validate) {
            const name = actualType ? actualType.name : 'object';
            throw new Error(`Cannot validate: ${name} does not have an associated schema`);
        }
        serialize(object, undefined, actualType, undefined, true);
    }
}
//# sourceMappingURL=json.js.map